<template>
  <div
    class="section-wrapper"
    :class="{ 'is-hovered': isHovered }"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <!-- 호버 오버레이 -->
    <transition name="section-hover-fade">
      <div v-if="isHovered" class="section-overlay">
        <!-- 좌측 중앙: 드래그 핸들 -->
        <div v-if="draggable" class="drag-handle">
          <holder-outlined style="font-size: 16px; color: #1677ff;" />
        </div>

        <!-- 우측 상단: 편집 버튼 -->
        <div class="edit-button" @click.stop="$emit('edit')">
          <edit-outlined style="margin-right: 4px;" />
          <span>{{ sectionName }}</span>
        </div>
      </div>
    </transition>

    <!-- 섹션 콘텐츠 슬롯 -->
    <slot />
  </div>
</template>

<script>
import { EditOutlined, HolderOutlined } from '@ant-design/icons-vue';

export default {
  name: 'SectionWrapper',

  components: {
    EditOutlined,
    HolderOutlined,
  },

  props: {
    sectionKey: {
      type: String,
      required: true,
    },
    sectionName: {
      type: String,
      required: true,
    },
    draggable: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['edit'],

  data() {
    return {
      isHovered: false,
    };
  },
};
</script>

<style scoped>
.section-wrapper {
  position: relative;
  transition: border-color 200ms ease, background-color 200ms ease;
  border: 2px solid transparent;
  border-radius: 8px;
  overflow: hidden;
}

.section-wrapper.is-hovered {
  border: 2px dashed #1677ff;
  background-color: rgba(22, 119, 255, 0.04);
}

.section-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  pointer-events: none;
}

/* 드래그 핸들 - 좌측 중앙 */
.drag-handle {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 6px 4px;
  cursor: grab;
  pointer-events: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.drag-handle:active {
  cursor: grabbing;
}

/* 편집 버튼 - 우측 상단 */
.edit-button {
  position: absolute;
  right: 12px;
  top: 12px;
  background: #1677ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  pointer-events: auto;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(22, 119, 255, 0.3);
  transition: background-color 150ms ease;
}

.edit-button:hover {
  background: #4096ff;
}

/* 페이드 트랜지션 */
.section-hover-fade-enter-active,
.section-hover-fade-leave-active {
  transition: opacity 200ms ease;
}

.section-hover-fade-enter-from,
.section-hover-fade-leave-to {
  opacity: 0;
}

/* 드래그 소스 섹션 - vuedraggable이 drag 시작 시 원본 요소에 적용 */
.section-dragging-source {
  opacity: 0.4;
  border: 2px dashed #1677ff !important;
}
</style>
